import React, { useState } from "react";
import { motion } from "framer-motion";
import "./ArithmeticOperatorsDemo.css";

const operators = [
  { label: "+ (сложение)", value: "+" },
  { label: "- (вычитание)", value: "-" },
  { label: "* (умножение)", value: "*" },
  { label: "/ (деление)", value: "/" },
  { label: "// (целочисленное деление)", value: "//" },
  { label: "% (остаток)", value: "%" },
  { label: "** (возведение в степень)", value: "**" },
];

const ArithmeticOperatorsDemo = () => {
  const [a, setA] = useState(10);
  const [b, setB] = useState(3);
  const [op, setOp] = useState("+");

  let result;
  try {
    // Safe eval for integer ops
    if (op === "//") {
      result = Math.floor(a / b);
    } else if (op === "%") {
      result = a % b;
    } else if (op === "**") {
      result = Math.pow(a, b);
    } else {
      // +, -, *, /
      result = eval(`${a} ${op} ${b}`);
    }
  } catch {
    result = "Error";
  }

  return (
    <div className="arith-demo">
      <h3>Интерактивный калькулятор операторов</h3>
      <div className="controls">
        <div className="input-group">
          <label>Число A:</label>
          <input
            type="number"
            value={a}
            onChange={e => setA(Number(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>Оператор:</label>
          <select value={op} onChange={e => setOp(e.target.value)}>
            {operators.map(o => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label>Число B:</label>
          <input
            type="number"
            value={b}
            onChange={e => setB(Number(e.target.value))}
          />
        </div>
      </div>

      <motion.div
        className="result"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <span>{a}</span>
        <span className="op">{op}</span>
        <span>{b}</span>
        <span className="eq">=</span>
        <span className="res">{result}</span>
      </motion.div>
    </div>
  );
};

export default ArithmeticOperatorsDemo;